import { guid } from './guid';

function hasGtag(): boolean {
  return typeof window !== 'undefined' && typeof (window as any).gtag === 'function';
}

export function trackEvent(action: string, params: Record<string, any> = {}): void {
  if (hasGtag()) {
    (window as any).gtag('event', action, { ...params, userId: guid() });
  }
}

export function initGlobalEventTracking(): void {
  trackEvent('app_loaded', { event_category: 'App' });
}

export const AnalyticsEvents = {
  ChatOpened: 'chat_opened',
  ChatMessageSent: 'chat_message_sent',
  NewChatCreated: 'new_chat_created',
  SettingsOpened: 'settings_opened',
  SettingsClosed: 'settings_closed',
  SettingsSaved: 'settings_saved',
  SettingsCanceled: 'settings_canceled',
  DatasetSelected: 'dataset_selected',
  PathsUpdated: 'paths_updated',
  DeepLearningToggled: 'deep_learning_toggled',
  LoginSuccess: 'login_success',
  CookieConsent: 'cookie_consent',
} as const;
